import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { cloneDeep } from 'lodash-es';

import { ComponentType } from '../../../profile-form/entities/component-types/component-types.entity';

import { SharedLanguageService } from '@language';
import { TranslateModule } from '@ngx-translate/core';
import { ExtendedBaseProfileField } from '../../../core/profiles/entities/extended-profile-field.entity';
import { PartialRecord } from '../../../core/records/entities/partial-record.class';
import { DialogConfig } from '../../../dynamic-dialog/entities/dialog-config.entity';
import { ShProfileFormModule } from '../../../profile-form/profile-form.module';

@Component({
    selector: 'sh-position-subfields-dialog',
    templateUrl: './position-subfields-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslateModule, ShProfileFormModule]
})
export class ShPositionSubFieldsDialogComponent implements OnInit {
    private readonly FULL_ADDRESS_FIELD_KEY = 'Address';

    public record: PartialRecord;
    public profileField: ExtendedBaseProfileField;
    public fullAddress: string;
    public fullAddressLabel: string;

    private readonly translateService: SharedLanguageService = inject(SharedLanguageService);

    constructor(public config: DialogConfig) {}

    ngOnInit(): void {
        this.record = this.config.data.record;
        // Forcibly change the control being used (clone first so we don't alter the original)
        this.profileField = this.convertProfileField(this.config.data.profileField);

        this.fullAddress = this.config.data.fullAddress;
        this.fullAddressLabel = this.translateService.translate(
            'modules.general.form.location.subfields-dialog-full-address'
        );
    }

    private convertProfileField(profileField: ExtendedBaseProfileField): ExtendedBaseProfileField {
        const convertedProfileField = cloneDeep(profileField);
        convertedProfileField.Control = ComponentType.MapField;

        // Hide Full address
        convertedProfileField.FieldDefinition.Children = convertedProfileField.FieldDefinition.Children?.filter(
            child => child.Key !== this.FULL_ADDRESS_FIELD_KEY
        );

        // Clear label
        convertedProfileField.DisplayLabel = '';

        return convertedProfileField;
    }
}
